/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CostPlusOverviewResource
 */
export interface CostPlusOverviewResource {
    /**
     * 
     * @type {number}
     * @memberof CostPlusOverviewResource
     */
    dailyRateExcludingTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof CostPlusOverviewResource
     */
    dailyRateIncludingTaxes?: number;
    /**
     * 
     * @type {number}
     * @memberof CostPlusOverviewResource
     */
    durationInMonths?: number;
    /**
     * 
     * @type {number}
     * @memberof CostPlusOverviewResource
     */
    monthlyWorkAmountInDays?: number;
    /**
     * 
     * @type {number}
     * @memberof CostPlusOverviewResource
     */
    latestLotWorkAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CostPlusOverviewResource
     */
    latestLotWorkAmountInDays?: number;
    /**
     * 
     * @type {number}
     * @memberof CostPlusOverviewResource
     */
    latestLotMonthValue?: number;
    /**
     * 
     * @type {number}
     * @memberof CostPlusOverviewResource
     */
    remainingLots?: number;
}

/**
 * Check if a given object implements the CostPlusOverviewResource interface.
 */
export function instanceOfCostPlusOverviewResource(value: object): value is CostPlusOverviewResource {
    return true;
}

export function CostPlusOverviewResourceFromJSON(json: any): CostPlusOverviewResource {
    return CostPlusOverviewResourceFromJSONTyped(json, false);
}

export function CostPlusOverviewResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CostPlusOverviewResource {
    if (json == null) {
        return json;
    }
    return {
        
        'dailyRateExcludingTaxes': json['dailyRateExcludingTaxes'] == null ? undefined : json['dailyRateExcludingTaxes'],
        'dailyRateIncludingTaxes': json['dailyRateIncludingTaxes'] == null ? undefined : json['dailyRateIncludingTaxes'],
        'durationInMonths': json['durationInMonths'] == null ? undefined : json['durationInMonths'],
        'monthlyWorkAmountInDays': json['monthlyWorkAmountInDays'] == null ? undefined : json['monthlyWorkAmountInDays'],
        'latestLotWorkAmount': json['latestLotWorkAmount'] == null ? undefined : json['latestLotWorkAmount'],
        'latestLotWorkAmountInDays': json['latestLotWorkAmountInDays'] == null ? undefined : json['latestLotWorkAmountInDays'],
        'latestLotMonthValue': json['latestLotMonthValue'] == null ? undefined : json['latestLotMonthValue'],
        'remainingLots': json['remainingLots'] == null ? undefined : json['remainingLots'],
    };
}

export function CostPlusOverviewResourceToJSON(value?: CostPlusOverviewResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'dailyRateExcludingTaxes': value['dailyRateExcludingTaxes'],
        'dailyRateIncludingTaxes': value['dailyRateIncludingTaxes'],
        'durationInMonths': value['durationInMonths'],
        'monthlyWorkAmountInDays': value['monthlyWorkAmountInDays'],
        'latestLotWorkAmount': value['latestLotWorkAmount'],
        'latestLotWorkAmountInDays': value['latestLotWorkAmountInDays'],
        'latestLotMonthValue': value['latestLotMonthValue'],
        'remainingLots': value['remainingLots'],
    };
}

